import React, { useEffect, useState } from 'react';
import PartnersFilterGallery, { Category, PartnerItem } from '../components/layout/PartnersFilterGallery';
import AcnTurk from '../assets/images/partners/acnturk.png';
import Allianz from '../assets/images/partners/allianz.png';
import Axa from '../assets/images/partners/axa.png';
import Demir from '../assets/images/partners/demir.png';
import Doga from '../assets/images/partners/doga.png';
import Ethica from '../assets/images/partners/ethica.png';
import Generali from '../assets/images/partners/generali.png';
import Halkbank from '../assets/images/partners/halkbank.png';
import Isbank from '../assets/images/partners/isbank.png';
import Magdeburger from '../assets/images/partners/magdeburger.png';
import Mapfre from '../assets/images/partners/mapfre.png';
import Neova from '../assets/images/partners/neova.png';
import Nippon from '../assets/images/partners/nippon.png';
import NN from '../assets/images/partners/nn.png';
import QNB from '../assets/images/partners/qnb.png';
import Quick from '../assets/images/partners/quick.png';
import Unico from '../assets/images/partners/unico.png';
import Vakifbank from '../assets/images/partners/vakifbank.png';
import AboutHero from '../components/common/AboutHero';
import Recete3 from '../assets/images/recete3.jpg';
import { toUrl } from '../lib/config';


const AnlasmaliSigortalarPage: React.FC = () => {
  const DEFAULT_HERO = {
    kicker: 'Megapark Hastanesi',
    title: 'Anlaşmalı Sigortalar',
    description:
      'Hastalarımızın sağlığını korumak için birçok farklı sigorta şirketi ile anlaşmalar yapıyoruz. Bu anlaşmalı kurumlar sayesinde hastalarımız, sağlık hizmetlerimizden daha kolay, güvenli ve ekonomik bir şekilde faydalanabilmektedir. Anlaşmalı sigortalar ile birlikte muayene, tetkik, tedavi ve çeşitli sağlık hizmetlerinde hastalarımıza ek kolaylıklar sunuyoruz.'
  };
  const [heroKicker, setHeroKicker] = React.useState<string>('');
  const [heroTitle, setHeroTitle] = React.useState<string>('');
  const [heroDesc, setHeroDesc] = React.useState<string>('');
  const DEFAULT_CATEGORIES: Category[] = [
    { id: "sigorta", label: "Sigorta Şirketleri" },
    { id: "indirim", label: "İndirim Anlaşmalı Kurumlar" },
    { id: "banka", label: "Banka / Vakıf / Sandık" },
    { id: "resmi", label: "Resmi Kurumlar" },
  ];
  const [categories, setCategories] = React.useState<Category[]>(DEFAULT_CATEGORIES);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const res = await fetch(toUrl('/api/anlasmali-categories'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const list = Array.isArray(data) ? data.slice().sort((a:any,b:any)=> (a.orderIndex??0)-(b.orderIndex??0)) : [];
        const mapped: Category[] = list.map((it:any) => ({ id: it.id, label: it.title }));
        if (!cancelled && mapped.length) setCategories(mapped);
      } catch {
        // keep defaults
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  // Fetch AboutHero content for this page
  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const res = await fetch(toUrl('/api/page-hero/anlasmali-sigortalar'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
        if (cancelled) return;
        setHeroKicker((obj.kicker || '').trim());
        setHeroTitle((obj.title || '').trim());
        setHeroDesc((obj.description || '').trim());
      } catch {
        // keep defaults
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);


   const PARTNERS: PartnerItem[] = [
    {
      id: 1,
      name: "AcnTurk",
      logo: AcnTurk,
      category: "indirim",
      description:
        "AcnTURK Sigorta, bireysel ve kurumsal müşterilerine farklı branşlarda sigorta çözümleri sunar.",
    },
    {
      id: 2,
      name: "Allianz",
      logo: Allianz,
      category: "indirim",
      description:
        "Allianz, geniş ürün yelpazesi ve güçlü hizmet ağıyla Türkiye’de faaliyet gösteren global bir sigorta şirketidir.",
    },
    {
      id: 3,
      name: "AXA",
      logo: Axa,
      category: "indirim",
      description:
        "AXA Sigorta, kasko, sağlık ve konut başta olmak üzere pek çok alanda güvence sağlayan köklü bir sigorta markasıdır.",
    },
    {
      id: 4,
      name: "Demir",
      logo: Demir,
      category: "indirim",
      href: "https://www.demirsaglik.com.tr",
      description:
        "Demir Sağlık ve Hayat, sağlık ve hayat sigortası ürünleriyle müşterilerine güvenilir çözümler sunar.",
    },
    {
      id: 5,
      name: "Doğa Sigorta",
      logo: Doga,
      category: "sigorta",
      href: "https://www.dogasigorta.com.tr",
      description:
        "Doğa Sigorta, farklı branşlarda hızlı ve pratik sigorta çözümleri sağlayan yerli bir sigorta şirketidir.",
    },
    {
      id: 6,
      name: "Ethica",
      logo: Ethica,
      category: "sigorta",
      description:
        "Ethica Sigorta, müşteri odaklı anlayışı ve yenilikçi hizmetleriyle dikkat çeken bir sigorta şirketidir.",
    },
    {
      id: 7,
      name: "Generali",
      logo: Generali,
      category: "sigorta",
      description:
        "Generali Sigorta, global bilgi birikimi ve geniş ürün portföyüyle Türkiye’de hizmet vermektedir.",
    },
    {
      id: 8,
      name: "Neova",
      logo: Neova,
      category: "sigorta",
      description:
        "Neova Katılım Sigorta, katılım esaslarına uygun çözümler sunan bir sigorta kuruluşudur.",
    },
    {
      id: 9,
      name: "Nippon",
      logo: Nippon,
      category: "sigorta",
      description:
        "Nippon Sigorta, bireysel ve kurumsal müşterilere özel kapsamlı sigorta ürünleri sunar.",
    },
    {
      id: 10,
      name: "NN",
      logo: NN,
      category: "resmi",
      description:
        "NN Hayat ve Emeklilik, hayat sigortası ve bireysel emeklilik alanında faaliyet göstermektedir.",
    },
    {
      id: 11,
      name: "QNB",
      logo: QNB,
      category: "resmi",
      href: "https://www.qnbfinansbank.com",
      description:
        "QNB Finansbank, geniş ürün ve hizmet yelpazesiyle bireysel ve kurumsal bankacılık hizmetleri sunar.",
    },
    {
      id: 12,
      name: "Quick",
      logo: Quick,
      category: "sigorta",
      description:
        "Quick Sigorta, dijital odaklı ve yenilikçi sigortacılık anlayışıyla öne çıkan bir sigorta şirketidir.",
    },
    {
      id: 13,
      name: "Unico",
      logo: Unico,
      category: "sigorta",
      href: "https://www.unicosigorta.com.tr",
      description:
        "Unico Sigorta, farklı ihtiyaçlara yönelik ürünleriyle müşterilerine güvenilir sigorta çözümleri sunar.",
    },
    {
      id: 14,
      name: "Vakifbank",
      logo: Vakifbank,
      category: "sigorta",
      href: "https://www.vakifbank.com.tr",
      description:
        "VakıfBank, köklü geçmişi ve güçlü altyapısıyla bireysel ve ticari bankacılık alanında hizmet verir.",
    },
    {
      id: 15,
      name: "Halkbank",
      logo: Halkbank,
      category: "banka",
      description:
        "Halkbank, KOBİ’lere sunduğu desteklerin yanı sıra bireysel bankacılıkta da geniş hizmetler sunar.",
    },
    {
      id: 16,
      name: "Isbank",
      logo: Isbank,
      category: "banka",
      description:
        "Türkiye İş Bankası, kapsamlı dijital bankacılık çözümleri ve geniş şube ağıyla öne çıkar.",
    },
    {
      id: 17,
      name: "Magdeburger",
      logo: Magdeburger,
      category: "banka",
      description:
        "Magdeburger Sigorta, farklı branşlarda sunduğu ürünlerle Türkiye’deki sigorta sektöründe yer almaktadır.",
    },
    {
      id: 18,
      name: "Mapfre",
      logo: Mapfre,
      category: "sigorta",
      description:
        "MAPFRE Sigorta, dünya genelindeki tecrübesini Türkiye sigorta pazarına taşıyan bir sigorta kuruluşudur.",
    },
  ];

  const [partners, setPartners] = useState<PartnerItem[]>([]);

  useEffect(() => {
    let cancelled = false;
    const normalizeLogo = (raw: string): string => {
      const input = (raw || '').trim();
      if (!input) return '';
      if (/^https?:\/\//i.test(input)) return input;
      // backend already sends /api/media/:uuid or other /api paths
      return toUrl(input);
    };
    const run = async () => {
      try {
        const res = await fetch(toUrl('/api/anlasmali-partners'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const list = Array.isArray(data) ? data.slice().sort((a:any,b:any)=> (a.orderIndex??0)-(b.orderIndex??0)) : [];
        const mapped: PartnerItem[] = list.map((it:any, idx:number) => ({
          id: it.id || idx,
          name: it.name || '',
          logo: normalizeLogo(it.logoUrl || ''),
          category: it.category || '',
          description: it.description || '',
          href: it.href || undefined,
        }));
        if (!cancelled && mapped.length) setPartners(mapped);
      } catch {
        // keep defaults
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  return (
    <>
      <AboutHero
        image={Recete3}
        kicker={heroKicker || DEFAULT_HERO.kicker}
        title={heroTitle || DEFAULT_HERO.title}
        description={heroDesc || DEFAULT_HERO.description}
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />
      <PartnersFilterGallery
        categories={categories}
        items={partners}
        initialCategory="sigorta"
        showSearch
        accent="#e30613"
        green="#2ba87a"
        onCategoryChange={(id) => console.log("Kategori:", id)}
      />
    </>
  );
};

export default AnlasmaliSigortalarPage;
